import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { MenuItem, InputAdornment, ListSubheader } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'

import { HEADERS_IMPORT_CSV_FILE } from '../../constansts'

import useStyles, { SearchInput } from './styles'

const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1

const Options = ({ handleChange }) => {
  const [searchText, setSearchText] = useState('')

  const classes = useStyles()

  const { formatMessage } = useIntl()

  const { requiredFields, optionalFields } = useMemo(() => {
    const requiredFields = []
    const optionalFields = []
    const filteredHeaders = HEADERS_IMPORT_CSV_FILE.filter(({ label }) =>
      containsText(label, searchText),
    )
    filteredHeaders.forEach((option) => {
      const { required } = option
      if (required) {
        requiredFields.push(option)
      } else {
        optionalFields.push(option)
      }
    })
    return { requiredFields, optionalFields }
  }, [searchText])

  const getMenuItem = (header, label) => {
    return (
      <MenuItem
        key={header}
        value={header}
        onClickCapture={(e) => {
          e.stopPropagation()
          handleChange({ value: header, label })
        }}
      >
        <FormattedMessage id={label} />
      </MenuItem>
    )
  }

  return (
    <>
      <ListSubheader className="p-0">
        <SearchInput
          size="small"
          value={searchText}
          autoFocus
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation()
          }}
          placeholder={formatMessage({ id: 'search' })}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className={classes.searchInputIcon} />
              </InputAdornment>
            ),
          }}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key !== 'Escape') {
              e.stopPropagation()
            }
          }}
        />
      </ListSubheader>
      <ListSubheader disableSticky={true}>
        <FormattedMessage
          id={'subscribers.import.previewTable.dragAndDrop.subheader1.label'}
        />
      </ListSubheader>
      {requiredFields.map((item) => {
        const { label, header } = item
        return getMenuItem(header, label)
      })}
      <ListSubheader disableSticky={true}>
        <FormattedMessage
          id={'subscribers.import.previewTable.dragAndDrop.subheader2.label'}
        />
      </ListSubheader>
      {optionalFields.map((item) => {
        const { label, header } = item
        return getMenuItem(header, label)
      })}
    </>
  )
}

Options.propTypes = {
  handleChange: PropTypes.func.isRequired,
}

export default Options
